import { ConversationArea, Interactable, PosterSessionArea, ViewingArea } from './CoveyTownSocket';
import { CompleteBookReturn } from '../generated/client/models/CompleteBookReturn';
import { CompleteAudioBookReturn } from '../generated/client';
/**
 * Test to see if an interactable is a conversation area
 */
export function isConversationArea(interactable: Interactable): interactable is ConversationArea {
  return 'occupantsByID' in interactable;
}

/**
 * Test to see if an interactable is a viewing area
 */
export function isViewingArea(interactable: Interactable): interactable is ViewingArea {
  return 'isPlaying' in interactable;
}

/**
 * Test to see if an interactable is a poster session area
 */
export function isPosterSessionArea(interactable: Interactable): interactable is PosterSessionArea {
  return 'stars' in interactable;
}

/**
 * Test to see if a book return is a textual book return
 */
export function isCompleteBookReturn(
  bookReturn: CompleteBookReturn | CompleteAudioBookReturn,
): bookReturn is CompleteBookReturn {
  return 'authors' in bookReturn;
}

/**
 * Test to see if a book return is an audio book return
 */
export function isCompleteAudioBookReturn(
  bookReturn: CompleteBookReturn | CompleteAudioBookReturn,
): bookReturn is CompleteAudioBookReturn {
  return 'author' in bookReturn;
}
